// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
import React from 'react';
import { makeAsyncComponent } from 'components/async_load';
import CustomLoader from "src/components/customComponents/CustomLoader/customLoader";
import ErrorBoundary from 'src/components/layout/ErrorBoundary';

const BaseLayout = makeAsyncComponent(
	"BaseApp",
	React.lazy(() => import("src/components/layout/Base")),
	<CustomLoader />,
	0);
class App extends React.PureComponent {
	render() {
		return (
			<div className='App'>
				<BaseLayout />
			</div>
		);
	}
}
export default App;